import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { useNavigate } from 'react-router-dom';
import { logger } from "../../utils/logger";
import { IMAGE_CONSTANTS } from "../../constants/ImageConstans";
import { COLORS_CONSTANTS } from "../../constants/Colors";
import { FONTS } from "../../constants/Fonts";
import {
    getStoredUserProfile,
} from "../../utils/userProfileStorage";
import { performLogout } from "../../utils/sessionLogout";

const ACTION_TYPES = {
    EDIT_PROFILE: "EDIT_PROFILE",
    LOGOUT: "LOGOUT",
};

const ProfileTileWithLogout = ({
    style = {},
    variant = "default",
}) => {

    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const [userProfileData, setUserProfileData] = useState(() => getStoredUserProfile());
    const isHeaderVariant = variant === "header";

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);

        // Prefer cached profile from login — no per-page API call
        const cached = getStoredUserProfile();
        if (cached) {
            setUserProfileData(cached);
        } else {
            logger.log('No cached user profile in localStorage');
        }

        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSignOut = () => {
        setOpen(false);
        performLogout(navigate);
    };

    const avatarSrc =
        userProfileData?.profileImage ||
        userProfileData?.profilePic ||
        userProfileData?.profilePicture ||
        (isHeaderVariant ? IMAGE_CONSTANTS.V2_HEADER_AVATAR : IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER);

    return (
        <div ref={ref} style={{ position: "relative", ...style }}>
            <div
                onClick={() => setOpen(!open)}
                style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    gap: isHeaderVariant ? 0 : 10,
                }}
            >
                <img
                    src={avatarSrc}
                    alt="profile"
                    style={
                        isHeaderVariant
                            ? {
                                width: 70,
                                height: 70,
                                borderRadius: "100px",
                                objectFit: "cover",
                                border: `1px solid ${COLORS_CONSTANTS.HEADER_AVATAR_BORDER}`,
                                background: COLORS_CONSTANTS.HEADER_AVATAR_BACKGROUND,
                                display: "block",
                            }
                            : {
                                width: 60,
                                height: 60,
                                borderRadius: "50%",
                                objectFit: "contain",
                                border: '1px solid #FFFFFF33',
                            }
                    }
                />
                {!isHeaderVariant && (
                    <>
                        <span style={{ color: COLORS_CONSTANTS.PAGE_TEXT, fontSize: 16, fontFamily: FONTS.MONTSERRAT_SEMIBOLD, fontWeight: 500 }}>
                            {userProfileData?.userName}
                        </span>
                        <img
                            src={IMAGE_CONSTANTS.V2_DROPDOWN_ARRAOW_DOWN}
                            alt="dropdown-arrow"
                            style={{
                                width: 20,
                                height: 10,
                                objectFit: "cover",
                            }}
                        />
                    </>
                )}
            </div>

            {open && (
                <div
                    style={{
                        position: "absolute",
                        top: "110%",
                        right: 0,
                        width: 180,
                        background: COLORS_CONSTANTS.GLASS_SURFACE,
                        border: `2px solid ${COLORS_CONSTANTS.GLASS_BORDER}`,
                        borderRadius: 24,
                        boxShadow: COLORS_CONSTANTS.GLASS_SHADOW,
                        backdropFilter: `blur(${COLORS_CONSTANTS.GLASS_BLUR})`,
                        WebkitBackdropFilter: `blur(${COLORS_CONSTANTS.GLASS_BLUR})`,
                        overflow: "hidden",
                        zIndex: 1000,
                    }}
                >
                    {userProfileData?.userName && (
                        <div
                            style={{
                                ...menuItemStyle,
                                cursor: "default",
                                color: COLORS_CONSTANTS.PAGE_TEXT,
                                borderBottom: "1px solid rgba(255,255,255,0.45)",
                            }}
                        >
                            {userProfileData.userName}
                        </div>
                    )}
                    <div
                        onClick={() => {
                            handleSignOut();
                        }}
                        style={{ ...menuItemStyle, color: COLORS_CONSTANTS.ERROR_TEXT_COLOR_1 }}
                    >
                        Logout
                    </div>
                </div>
            )}
        </div>
    );
};

ProfileTileWithLogout.propTypes = {
    style: PropTypes.object,
    variant: PropTypes.oneOf(["default", "header"]),
};

const menuItemStyle = {
    padding: "12px 16px",
    cursor: "pointer",
    color: COLORS_CONSTANTS.PAGE_TEXT,
    fontSize: 16,
    borderBottom: "1px solid rgba(255,255,255,0.35)",
};

export default ProfileTileWithLogout;
export { ACTION_TYPES };
